// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { Fragment } from 'react';
import { Chip } from '@mui/material';
import { InstrumentIdentifier } from '@daml.js/utility-registry-holding-v0/lib/Utility/Registry/Holding/V0/Types';
import PartyDisplay from '../../components/PartyDisplay';

interface InstrumentIdentifiersProps {
  instrumentIdentifiers: InstrumentIdentifier[];
}

const InstrumentIdentifiers: React.FC<InstrumentIdentifiersProps> = ({ instrumentIdentifiers }) => {
  return (
    <>
      {instrumentIdentifiers.map((instrumentIdentifier, index) => {
        return (
          <Fragment
            key={
              instrumentIdentifier.source + instrumentIdentifier.id + instrumentIdentifier.scheme
            }
          >
            <Chip label={<PartyDisplay party={instrumentIdentifier.source} />} />
            <Chip label={instrumentIdentifier.id} />
            <Chip label={instrumentIdentifier.scheme} />
            {index < instrumentIdentifiers.length - 1 && ' ∧ '}
          </Fragment>
        );
      })}
    </>
  );
};

export default InstrumentIdentifiers;
